import { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export function useApprovals(status = "pending") {
    const { activeOrg } = useAuth();
    const [approvals, setApprovals] = useState([]);
    const [loading, setLoading] = useState(true);

    const refetch = useCallback(async () => {
        if (!activeOrg?.id) { setApprovals([]); setLoading(false); return; }
        setLoading(true);
        try {
            const params = { org_id: activeOrg.id };
            if (status) params.status = status;
            const { data } = await api.get("/approvals", { params });
            setApprovals(data.approvals || []);
        } finally { setLoading(false); }
    }, [activeOrg?.id, status]);

    useEffect(() => { refetch(); }, [refetch]);

    return { approvals, loading, refetch };
}
